import { useEffect, useState } from "react";
import Accordion from "../../../UiKit/Accordion/Accordion";
import stl from "./SpecsSection.module.css";

const SpecsSection = ({ selectedOptions, isAutos, specs }) => {
  const [openedAccordionIndex, setOpenedAccordionIndex] = useState(null);

  const handelToggle = (index) => {
    setOpenedAccordionIndex(index === openedAccordionIndex ? null : index);
  };

  const isYearSelected = selectedOptions.find(
    (option) => option.filterField === "year"
  );

  useEffect(() => {
    return () => {
      setOpenedAccordionIndex(null);
    };
  }, [selectedOptions]);

  if (!isYearSelected || !isAutos || !specs) return null;

  return (
    <section className={stl.wrapper}>
      <h2>{specs?.title}</h2>
      {specs?.items?.map((item, index) => {
        return (
          <Accordion
            key={index}
            isOpen={index === openedAccordionIndex}
            onClick={() => handelToggle(index)}
            headTitle={item?.title}>
            {item?.sub_items?.length ? (
              item?.sub_items?.map((subItem, subIndex) => (
                <div key={subIndex} className={stl.subWrapper}>
                  <h4>{subItem?.title}</h4>
                  <p>{subItem?.desc}</p>
                </div>
              ))
            ) : (
              <p>{item?.desc}</p>
            )}
          </Accordion>
        );
      })}
    </section>
  );
};

export default SpecsSection;
